import React, { ReactNode } from 'react'
import styled from '@emotion/styled'
import {
  space,
  SpaceProps,
  layout,
  LayoutProps,
  border,
  BorderProps
} from 'styled-system'

interface SchedulableActionProps extends SpaceProps, BorderProps, LayoutProps {
  /**
   * Load components on the right and vertically aligned.
   */
  actions: ReactNode
  children?: ReactNode
}

/**
 * SchedulableAction is a variation of the Box component meant to load the actions prop on the right and vertically aligned
 * The ...other props is necessary for the styled-system props.
 */

const SchedulableAction = ({
  actions,
  children,
  ...other
}: SchedulableActionProps) => {
  return (
    <StyledSchedulableAction {...other}>
      <StyledContent>{children}</StyledContent>
      <StyledActions>{actions}</StyledActions>
    </StyledSchedulableAction>
  )
}

export default SchedulableAction

const StyledSchedulableAction = styled.div(
  ({ theme }) => ({
    padding: theme.space[2],
    borderTop: theme.border,
    borderBottom: theme.border,
    display: 'flex',
    alignSelf: 'flex-start',
    width: '100%'
  }),
  space,
  layout,
  border
)

const StyledContent = styled.div(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  flex: '1 0 0',
  // Link
  '& > a': {
    color: theme.colors.text.secondary,
    width: '100%'
  },
  '& div + a': {
    marginTop: theme.space[1]
  },
  // Text
  '& div + p': {
    marginTop: theme.space[1],
    marginBottom: 0
  }
}))

const StyledActions = styled.div(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'flex-end',
  marginLeft: theme.space[2],
  'div + button': {
    marginTop: theme.space[4]
  }
}))
